import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  sharedActions,
  showDeleteErrorTaxEntryAlert,
} from './store/actions';

import { AlertMessages } from './constants';

const TaxEntryAdminColumnRenderer = ({
  data,
  rowIndex,
  showEditTaxEntryModal,
  showDeleteTaxEntryModal,
  showDeleteErrorTaxEntryAlert,
}) => {
  const showEditModal = useCallback(() => {
    showEditTaxEntryModal({ ...data });
  }, [showEditTaxEntryModal, data]);

  const showDeleteModal = useCallback(() => {
    if ( data.slGlJournalExists !== 'undefined' && data.slGlJournalExists === 1 ) {
      showDeleteErrorTaxEntryAlert(AlertMessages.slGlJournalExists);
    } else {
      showDeleteTaxEntryModal({ entity: data, rowIndex });
    }
  }, [showDeleteTaxEntryModal, showDeleteErrorTaxEntryAlert, data, rowIndex]);

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Tax Entry"
        onClick={showEditModal}
      >
        <PencilIcon size={16} className="cell-icon" />
      </button>
      <button
        className="cell-icon-button"
        title="Delete Tax Entry"
        onClick={showDeleteModal}
      >
        <TrashIcon size={16} className="cell-icon" />
      </button>
    </div>
  );
};

TaxEntryAdminColumnRenderer.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string,
    activity: PropTypes.string,
    slGlJournalExists: PropTypes.number,
  }).isRequired,

  showEditTaxEntryModal: PropTypes.func.isRequired,
  showDeleteTaxEntryModal: PropTypes.func.isRequired,
  showDeleteErrorTaxEntryAlert: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default connect(
  null,
  {
    showEditTaxEntryModal: sharedActions.showModalForAddEdit,
    showDeleteTaxEntryModal: sharedActions.showModalForRemove,
    showDeleteErrorTaxEntryAlert,
  }
)(TaxEntryAdminColumnRenderer);
